import React, { useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { useTranslation } from 'react-i18next';
import ProductFilterContext from '@stone/components/listing/ProductFilterContext';
import { getZeroPadNumber } from '@utils/stringUtils';
import ProductFilterValue from '@stone/components/listing/ProductFilterValue';
import Accordion from '@ui/accordion/Accordion';
import AccordionItem from '@ui/accordion/AccordionItem';
import Button from '@stone/ui/button/Button';
const ProductFilterRefinementTabs = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    // const { selectedFilters } = useSelector((state: ApplicationState) => state.search);
    const { expandedMenu, selectedRefinement } = useContext(ProductFilterContext);
    const [tabIndex, setTabIndex] = useState(0);
    // const getFilter = (filterId: string) => {
    //   return selectedFilters.find((filter) => {
    //     return filter.id === filterId;
    //   });
    // };
    const filterCount = (refinemnet) => {
        var _a;
        const count = ((_a = refinemnet === null || refinemnet === void 0 ? void 0 : refinemnet.values.filter((val) => val.selected)) === null || _a === void 0 ? void 0 : _a.length) || 0;
        return (!!count && (React.createElement("span", { className: "filter-counter", "aria-label": t('refine.currentlyselectedfilters') + ' ' + count },
            "\u00A0",
            getZeroPadNumber(count, 2))));
    };
    useLayoutEffect(() => {
        if (expandedMenu !== 'refine')
            setTabIndex(0);
    }, [expandedMenu]);
    useEffect(() => {
        if (selectedRefinement) {
            setTabIndex(props.refinements.findIndex(({ attributeID }) => attributeID === selectedRefinement) || 0);
        }
    }, [selectedRefinement, props.refinements]);
    return (React.createElement(Tabs, { className: classNames('col-18 subnav-refinements-list', { 'is-visible': expandedMenu === 'refine' }), id: "filter-refinements", onBlur: props.onBlur, selectedIndex: tabIndex, forceRenderTabPanel: true, onSelect: (index) => {
            props.onSelected && props.onSelected(props.refinements[index]);
        } },
        React.createElement(TabList, { className: "react-tabs__tab-list" }, (_a = props.refinements) === null || _a === void 0 ? void 0 : _a.map((refinement, i) => (React.createElement(Tab, { className: "refine-button", selectedClassName: "refine-button--selected", key: refinement.attributeID },
            React.createElement("span", null,
                refinement.displayName,
                filterCount(refinement)))))),
        React.createElement("div", { className: "subnav-content subnav-content-drop subnav-refinements-content" }, (_b = props.refinements) === null || _b === void 0 ? void 0 : _b.map((refinement, i) => (React.createElement(TabPanel, { className: "subnav-content-fixed", selectedClassName: 'refinement-expanded', key: refinement.attributeID },
            React.createElement(ProductFilteRefinementList, Object.assign({ refinement: refinement }, props, { className: 'col-lg-2' }))))))));
};
const AccordionTitle = (title, counter) => (React.createElement("span", { className: "font__title" },
    title,
    " ",
    counter));
const ProductFilteRefinementAccordion = (props) => {
    const { t } = useTranslation();
    const { filterRefinements } = useContext(ProductFilterContext); //,expandedMenu, selectedRefinement
    // const { selectedFilters } = useSelector((state: ApplicationState) => state.search);
    // const getFilter = (filterId: string) => {
    //   return selectedFilters.find((filter) => {
    //     return filter.id === filterId;
    //   });
    // };
    const filterCount = (refinemnet) => {
        var _a;
        const count = ((_a = refinemnet === null || refinemnet === void 0 ? void 0 : refinemnet.values.filter((val) => val.selected)) === null || _a === void 0 ? void 0 : _a.length) || 0;
        return (!!count && (React.createElement("span", { className: "filter-counter", "aria-label": t('refine.currentlyselectedfilters') + ' ' + count },
            "\u00A0",
            getZeroPadNumber(count, 2))));
    };
    return (React.createElement("div", { id: "filter-refinements", className: "subnav-content subnav-content-modal subnav-refinements-content" },
        React.createElement("div", { className: "subnav-content-fluid" },
            React.createElement(Accordion, null, filterRefinements.map((refinement, i) => (React.createElement(AccordionItem, { key: i, isTitleMarkup: true, title: AccordionTitle(refinement.displayName, filterCount(refinement)), accordionId: `filters-${refinement.attributeID}` },
                React.createElement("ul", null, refinement === null || refinement === void 0 ? void 0 : refinement.values.map((refinementValue, _i) => (React.createElement(ProductFilterValue, { fromSearch: props.fromSearch, refinement: refinement, refinementValue: refinementValue, key: _i, index: _i })))))))),
            React.createElement("div", { className: "subnav-refinements-actions" },
                React.createElement(Button, { type: "button", className: "btn-refinement-clear", onClick: () => {
                        props.onReset && props.onReset();
                    }, cls: ['button--secondary'] }, t('button.clearall')),
                React.createElement("a", { href: '#ref-position-el', onClick: (e) => {
                        e.preventDefault();
                        props.onApply && props.onApply();
                    }, className: "button button--primary btn-refinement-apply" },
                    React.createElement("span", null, t('refine.showresults', {
                        0: props.resultsCounter,
                    })))))));
};
const dropShow = {
    visibility: 'visible',
    opacity: 1,
    zIndex: 0,
    backgroundColor: 'rgba(255,255,255,1)',
};
const dropHide = {
    opacity: 0,
    backgroundColor: 'rgba(255,255,255,0)',
    transitionEnd: { visibility: 'hidden', zIndex: -1 },
};
const ProductFilteRefinementList = (props) => {
    var _a;
    const { selectedRefinement, expandedMenu } = useContext(ProductFilterContext);
    const { t } = useTranslation();
    const [current, setCurrent] = useState(false);
    const sectionProgrammaticClassName = useMemo(() => {
        var _a;
        return ((_a = props.refinement) === null || _a === void 0 ? void 0 : _a.values.length) < 7 ? 'one-column' : 'multi-colums';
    }, [props.refinement]);
    useEffect(() => {
        if (expandedMenu == 'refine' && selectedRefinement == props.refinement.attributeID) {
            setCurrent(true);
        }
        else {
            setCurrent(false);
        }
    }, [selectedRefinement, expandedMenu]);
    return (React.createElement(React.Fragment, null,
        React.createElement(motion.div, { initial: dropHide, transition: { duration: 0.3 }, animate: (current ? dropShow : dropHide), id: 'filters-' + props.refinement.attributeID, className: classNames('subnav-filters__refinements-section', sectionProgrammaticClassName, { expanded: current }) },
            React.createElement("div", { className: "container--fluid" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "subnav-filters__refinement-overflow offset-lg-3 col-lg-21" },
                        React.createElement("ul", null, (_a = props.refinement) === null || _a === void 0 ? void 0 : _a.values.map((refinementValue, _i) => (React.createElement(ProductFilterValue, { type: (props.refinement.isPriceRefinement && 'radio') || 'checkbox', replaceFilter: props.refinement.isPriceRefinement, fromSearch: props.fromSearch, refinement: props.refinement, refinementValue: refinementValue, key: _i, index: _i })))))))),
        React.createElement("div", { className: "subnav-refinements-actions" },
            React.createElement(Button, { type: "button", className: "btn-refinement-clear", customTabIndex: !current ? -1 : null, ariaHidden: !current, onClick: () => {
                    props.onReset && props.onReset();
                }, cls: ['button--secondary'] }, t('button.clearall')),
            React.createElement("a", { href: '#ref-position-el', onClick: (e) => {
                    e.preventDefault();
                    props.onApply && props.onApply();
                }, "aria-hidden": !current, tabIndex: !current ? -1 : null, className: "button button--primary btn-refinement-apply" },
                React.createElement("span", null, t('refine.showresults', {
                    0: props.resultsCounter,
                }))))));
};
export { ProductFilteRefinementAccordion, ProductFilteRefinementList, ProductFilterRefinementTabs };
